import { Location } from '@angular/common';
import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import 'rxjs/add/operator/finally';
import { Observable } from 'rxjs/Observable';
import { BaseComponent } from '../../core/components';
import { UserModel } from '../../models';
import { AccountService, CommonService, DepartmentService, UserService } from '../../services';
import { DeviceHelper } from '../../shared/helpers';
import { UsersListComponent } from '../../shared/components/users-list/users-list.component';

@Component({
    selector: 'app-users-create',
    templateUrl: './users-create.component.html',
    styleUrls: ['../layout/layout.component.scss']
})
export class UsersCreateComponent extends BaseComponent implements OnInit {
    @ViewChild('accountsFilter') accountsFilterEl: ElementRef;
    @ViewChild('roleFilter') roleFilterEl: ElementRef;
    @Output() userListView = new EventEmitter();
    public model: any;
    public selectedAccount: any;
    public accountsList: any = [];
    public userRolesList: any = [];
    public hideAccountSelect: boolean = true;
    public departmentList: any = [];
    public showSpinner: boolean = false;
    isMobile: boolean = false;
    constructor(
        private accountService: AccountService,
        private departmentService: DepartmentService,
        private commonService: CommonService,
        private userService: UserService,
        private toastr: ToastsManager,
        private route: ActivatedRoute,
        private router: Router,
        public activeModal: NgbActiveModal,
        private location: Location,
        private vRef: ViewContainerRef) {
        super(router);
        this.toastr.setRootViewContainerRef(vRef);
    }

    public ngOnInit() {


        localStorage.setItem('currentModuleId', '11');
        if (DeviceHelper.isMobile()) {
            this.isMobile = true;
        }

        let currentUser = super.currentLoggedUser();
        this.model = new UserModel();
        this.model.IsActive = true;
        // this.route.params.subscribe((params) => {
        //     if (params) {
        //         const accountId = params['account'];

        //     }
        // });

        this.selectedAccount = this.accountId;
        this.model.AccountId = this.accountId;

        this.setDefaults();
    }
    public accountId: any;
    public setDefaults() {
        this.loadUserRoles();
        this.loadDepartments(this.accountId);
        this.model.AccountId = this.accountId;
        this.model.IsActive = true;
    }

    public validateEmail(email) {
        var re = /\S+@\S+\.\S+/;
        return re.test(email);
    }

    public saveChanges() {

        if (this.validateEmail(this.model.EmailAddress)) {
            this.showSpinner = true;
            this.userService.saveUser(this.model)
                .catch((err: any) => {
                    this.toastr.error(err, 'Error');
                    return Observable.throw(err);
                }).finally(() => {
                    setTimeout(() => {
                        this.closeUserCreateView();
                    }, 1000);
                })
                .subscribe((response) => {
                    if (response.ErrorCode) {
                        this.toastr.error(response.Message, "Error");
                    }
                    else {
                        this.toastr.success("User created successfully", "Success");
                        this.ngOnInit();
                    }
                });
        } else {
            this.toastr.error('Invalid Email Address', 'Error');
        }
    }

    public loadUserRoles(): void {
        //getAllUserRoles
        this.commonService.getAllUserRoles()
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {

            })
            .subscribe((response: any) => {
                this.userRolesList = response.Data.filter((item) => {
                    return item.Name.indexOf('(user)') > -1;
                });
            });
    }

    public loadDepartments(accountId) {
        this.departmentService.getDepartmentByAccountId(accountId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {

            })
            .subscribe((response: any) => {
                this.departmentList = response.Data;
            });
    }

    public emailAddressChange() {
        this.model.UserName = this.model.EmailAddress;
    }

    public isSendCreds(evt) {
        if (evt.target.checked) {
            this.model.IsSendCreds = true;
        } else {
            this.model.IsSendCreds = false;
        }
    }

    public closeUserCreateView() {
        this.model = new UserModel();
        this.activeModal.close({ 'success': true });

        //this.userListView.emit();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/users/users-create.component.ts